import { Fragment } from 'react';

import { Container, SectionText, Tabs } from '@/atoms';
import { VARIANT_MAPS } from '@/atoms/section-text/SectionText';
import { SwiperCustom } from '@/molecules';
import CardConIframePopUp from '@/organisms/cardConIframePopUp';

import type { FunctionComponent } from 'react';
import type { TypeSharedSpacesProps } from './types';

/**
 * SharedSpaces
 */
export const SharedSpaces: FunctionComponent<TypeSharedSpacesProps> = ({
  className = '',
  caption,
  title,
  desc,
  tabs,
  cutLevel,
  cutLevelMobile,
  variant,

  id,
  ...config
}: TypeSharedSpacesProps) => (
  <>
    <Container
      className={`flex flex-col gap-10 ${className}`}
      backgroundColorBottom={config.backgroundColorBottom}
      backgroundColorTopMobile={config.backgroundColorTopMobile}
      backgroundColorTop={config.backgroundColorTop}
      backgroundColorBottomMobile={config.backgroundColorBottomMobile}
      cutLevel={cutLevel === null ? 50 : cutLevel}
      cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
      hasCutLevel={config.hasCutLevel}
      id={id}
    >
      <SectionText
        title={title}
        desc={desc}
        direction="row"
        textAlign="start"
        variant={variant}
        caption={caption}
      />

      <Tabs tabsName={tabs.map(({ title }) => title)}>
        {tabs.map(({ description = null, cards = [] }, index) => (
          <Fragment key={index}>
            {description && (
              <p className={`mb-12 ${VARIANT_MAPS[variant]}`}>{description}</p>
            )}

            {cards && Array.isArray(cards) && cards.length > 0 && (
              <div className="-mx-5 md:ml-0">
                <SwiperCustom
                  gap={20}
                  navigation
                  scrollbar
                  slidesPerView={cards.length > 3 ? 3.5 : 3}
                  slidesPerViewMobile={1.3}
                >
                  {cards.map(
                    ({ caption, description, image, title, iframe }, index) => (
                      <CardConIframePopUp
                        key={index}
                        index={index}
                        caption={caption}
                        description={description}
                        image={image}
                        title={title}
                        variant={variant}
                        iframe={iframe}
                        length={cards.length}
                      />
                    )
                  )}
                </SwiperCustom>
              </div>
            )}
          </Fragment>
        ))}
      </Tabs>
    </Container>
  </>
);

SharedSpaces.displayName = 'SharedSpaces';
